import React from 'react';
import { Tooltip } from '@mui/material';

export const fundingCell = (fundingScheme: string[]): React.ReactNode => {
  return (
    <>
      {fundingScheme?.map((funding, index) => (
        <div
          key={index}
          className="w-full text-center whitespace-nowrap overflow-hidden text-ellipsis mb-2"
        >
          <Tooltip title={funding} placement="bottom">
            <span>{funding}</span>
          </Tooltip>
        </div>
      ))}
    </>
  );
};
